import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/fa`; // Adjust this as necessary

export const getFactureById = (id) => axios.get(`${API_BASE_URL}/getfacture/${id}`);

export const getAllFactures = (params) => 
    axios.get(`${API_BASE_URL}/getallfactures`, { params });
  
export const validateFacture = (refFAC) => axios.post(`${API_BASE_URL}/validatefacture/${refFAC}`);
export const validateFactureTree = (refFAC) => axios.post(`${API_BASE_URL}/validatefacturetree/${refFAC}`);
export const getAllDetailFacturesByFacture = (refFAC) => axios.get(`${API_BASE_URL}/getallitems/${refFAC}`);
export const cancelFacture = (refFAC) => axios.post(`${API_BASE_URL}/cancelFacture/${refFAC}`);

export const saveFacture = (refFAC, factureData, detailsData) => 
    axios.put(`${API_BASE_URL}/savefacture/${refFAC}`, { facture: factureData, details: detailsData });// From your frontend API

export const unvalidateFacture = (refFAC) => 
    axios.post(`${API_BASE_URL}/unvalidatefacture/${refFAC}`);


export const deleteFacture = (refFAC) => 
    axios.delete(`${API_BASE_URL}/deletefacture/${refFAC}`);

export const getFacturesByClient = (compte) => 
    axios.get(`${API_BASE_URL}/getfacturesbyclient/${compte}`);

// Seed DBF upload APIs
export const uploadFacturesDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-factures`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadFacturesDetailsDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-details`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const uploadBothFacturesDBF = (formData) =>
  axios.post(`${API_BASE_URL}/seed/upload-both`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
